/* Vanilla-JS port of the original Angular app's interactivity. Shopify themes are
   server-rendered Liquid, not an SPA, so there's no component framework here — this
   file wires up the same behaviors (cart drawer, zoom, quick add, wishlist) by hand
   against Shopify's Ajax Cart API. */
(function () {
  'use strict';

  /* ---------- Page loader: shows the bow gif until the page is fully ready,
     covers slow connections instead of the browser's own loading indicator ---------- */
  var pageLoader = document.getElementById('page-loader');
  if (pageLoader) {
    var hideLoader = function () { pageLoader.classList.add('hidden'); };
    window.addEventListener('load', hideLoader);
    // Safety net in case 'load' is delayed by a slow third-party asset.
    setTimeout(hideLoader, 6000);

    // Show the bow again the instant Checkout is clicked, so the jump to
    // Shopify's hosted checkout is covered by our loader instead of a blank
    // moment before the browser's own spinner appears.
    document.querySelectorAll('.checkout').forEach(function (el) {
      el.addEventListener('click', function () { pageLoader.classList.remove('hidden'); });
    });
  }

  /* ---------- Father/daughter walk animation: kept paused (see theme.css)
     until the page has genuinely finished loading, so its 15s clock always
     starts fresh from 0% instead of possibly beginning mid-cycle. ---------- */
  var newsStory = document.querySelector('.news-story');
  if (newsStory) {
    var startStoryAnim = function () { newsStory.classList.add('is-ready'); };
    window.addEventListener('load', startStoryAnim);
    setTimeout(startStoryAnim, 6000);
  }

  /* ---------- Shop filters belt: left/right arrow buttons scroll the pill
     row by hand instead of it wrapping to multiple lines. Dragging/swiping
     the row directly still works too, for free, via overflow-x:auto in
     theme.css — these buttons are just an explicit alternative. ---------- */
  document.querySelectorAll('[data-filters-track]').forEach(function (track) {
    var wrap = track.closest('.shop-filters-wrap');
    if (!wrap) return;
    var prevBtn = wrap.querySelector('[data-filters-prev]');
    var nextBtn = wrap.querySelector('[data-filters-next]');
    var step = function () { return track.clientWidth * 0.8; };
    function updateArrows() {
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 1;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollLeft -= step(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollLeft += step(); });
    track.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    updateArrows();
  });

  /* ---------- PDP related-products fallback: only present when a product
     is in neither the New nor Classic collection family (see snippets/
     related-products.liquid) — fetches Shopify's native recommendations via
     sections/pdp-recommendations.liquid and injects the returned product
     cards into the grid. ---------- */
  document.querySelectorAll('[data-recommendations-url]').forEach(function (section) {
    var grid = section.querySelector('[data-recommendations-grid]');
    if (!grid) return;
    fetch(section.getAttribute('data-recommendations-url'))
      .then(function (res) { return res.text(); })
      .then(function (html) {
        // Shopify wraps the fetched section's render in its own
        // #shopify-section-<id> div — that wrapper's contents are exactly
        // sections/pdp-recommendations.liquid's output (bare product cards,
        // no grid element of its own), so pull from there.
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var wrapper = doc.querySelector('[id^="shopify-section-"]');
        grid.innerHTML = wrapper ? wrapper.innerHTML : html;
      })
      .catch(function () {});
  });

  /* ---------- Lazy background video: only start loading/playing once the
     section actually scrolls into view, instead of on page load ---------- */
  document.querySelectorAll('[data-lazy-video]').forEach(function (wrap) {
    var vid = wrap.querySelector('video');
    if (!vid) return;
    if (!('IntersectionObserver' in window)) { vid.play().catch(function () {}); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          vid.play().catch(function () {});
        } else {
          vid.pause();
        }
      });
    }, { rootMargin: '200px' });
    io.observe(wrap);
  });

  /* ---------- Manifesto video sound: plays muted (required for autoplay to
     work at all); audio only turns ON when a visitor deliberately clicks
     the toggle — a real click always satisfies browsers' autoplay-with-sound
     restriction, unlike trying to unmute automatically. Turning sound back
     OFF automatically once the section scrolls out of view is fine to do
     without a click, though — browsers only restrict *starting* audio
     without a gesture, never stopping it — so that direction is automatic. */
  document.querySelectorAll('[data-manifesto-video], [data-moments-audio]').forEach(function (wrap) {
    var vid = wrap.querySelector('video, audio');
    // Some sections (e.g. Moments We Live For) show the toggle in two
    // places — over the desktop image pair and over the mobile slider —
    // since only one of those is ever visible at a time. Both control the
    // same shared audio/video, so every toggle found gets kept in sync.
    var btns = wrap.querySelectorAll('[data-sound-toggle]');
    if (!vid || !btns.length) return;

    function setSoundState(muted) {
      vid.muted = muted;
      btns.forEach(function (btn) {
        btn.setAttribute('aria-pressed', String(!muted));
        btn.setAttribute('aria-label', muted ? 'Turn sound on' : 'Turn sound off');
      });
      vid.play().catch(function () {});
    }

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setSoundState(!vid.muted);
      });
    });

    if ('IntersectionObserver' in window) {
      /* threshold 0 (not e.g. 0.6) fires only on the fully-in/fully-out
         boundary, not a fuzzy mid-range mark — with the site's smooth-scroll
         CSS, a mid-range threshold can get crossed back and forth while a
         scroll animation is still settling, muting right after a click
         re-enabled it. */
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && !vid.muted) setSoundState(true);
        });
      }, { threshold: 0 });
      io.observe(wrap);
    }
  });

  /* ---------- Toast ---------- */
  var toastEl = document.querySelector('.toast');
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 2200);
  }
  window.ukiyoToast = toast;

  /* ---------- Header scroll state + mobile menu ---------- */
  var header = document.querySelector('header');
  function onScroll() {
    if (!header) return;
    header.classList.toggle('scrolled', window.scrollY > 8);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  var burger = document.querySelector('.burger');
  var mobileMenu = document.querySelector('.mobile-menu');
  if (burger && mobileMenu) {
    burger.addEventListener('click', function () {
      mobileMenu.classList.toggle('open');
    });
  }

  /* Footer link accordions (mobile only — CSS keeps them always-open above the breakpoint) */
  document.querySelectorAll('[data-foot-toggle]').forEach(function (heading) {
    heading.addEventListener('click', function () {
      heading.closest('.foot-accordion').classList.toggle('open');
    });
  });

  /* Profile dropdown (click to toggle on touch devices; CSS :hover handles desktop) */
  document.querySelectorAll('.profile-item > a').forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      var menu = trigger.parentElement.querySelector('.profile-menu');
      if (menu) menu.classList.toggle('open');
    });
  });
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.profile-menu.open').forEach(function (menu) {
      if (!menu.parentElement.contains(e.target)) menu.classList.remove('open');
    });
  });

  /* ---------- "By Product" nested menu (desktop flyout + mobile accordion) ---------- */
  document.querySelectorAll('[data-product-toggle]').forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var panel = trigger.nextElementSibling;
      if (!panel) return;
      var isOpen = panel.classList.toggle('open');
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.nested-subnav.open, .mobile-sub-panel.open').forEach(function (panel) {
      var toggle = panel.previousElementSibling;
      if (panel.contains(e.target) || (toggle && toggle.contains(e.target))) return;
      panel.classList.remove('open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  });

  /* ---------- Smooth scroll to in-page anchors, offset for sticky header ---------- */
  document.querySelectorAll('[data-scroll-to]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      var id = el.getAttribute('data-scroll-to');
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      var headerHeight = header ? header.offsetHeight : 90;
      var top = target.getBoundingClientRect().top + window.scrollY - headerHeight - 24;
      window.scrollTo({ top: top, behavior: 'smooth' });
      if (mobileMenu) mobileMenu.classList.remove('open');
    });
  });

  /* ---------- Wishlist (localStorage, same approach as the original app) ---------- */
  var WISHLIST_KEY = 'ukiyo-wishlist';
  function loadWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch (e) { return []; }
  }
  function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  }
  function isWishlisted(handle) {
    return loadWishlist().indexOf(handle) !== -1;
  }
  function refreshWishlistButtons() {
    var list = loadWishlist();
    document.querySelectorAll('.wish-btn[data-handle]').forEach(function (btn) {
      btn.classList.toggle('active', list.indexOf(btn.getAttribute('data-handle')) !== -1);
    });
    var countEls = document.querySelectorAll('[data-wishlist-count]');
    countEls.forEach(function (el) { el.textContent = '(' + list.length + ')'; el.hidden = list.length === 0; });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.wish-btn[data-handle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-handle');
    var list = loadWishlist();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
      toast('Added to wishlist');
    } else {
      list.splice(idx, 1);
      toast('Removed from wishlist');
    }
    saveWishlist(list);
    refreshWishlistButtons();
  });
  refreshWishlistButtons();

  /* ---------- Cart drawer: Shopify Ajax Cart API ---------- */
  var drawer = document.querySelector('.drawer');
  var scrim = document.querySelector('.scrim');
  var cartCountEls = document.querySelectorAll('[data-cart-count]');

  function openCart() {
    if (drawer) drawer.classList.add('open');
    if (scrim) scrim.classList.add('open');
    refreshCartDrawer();
  }
  function closeCart() {
    if (drawer) drawer.classList.remove('open');
    if (scrim) scrim.classList.remove('open');
  }
  window.ukiyoOpenCart = openCart;
  window.ukiyoCloseCart = closeCart;

  document.querySelectorAll('[data-open-cart]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });
  document.querySelectorAll('[data-close-cart]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); closeCart(); });
  });
  if (scrim) scrim.addEventListener('click', closeCart);

  function updateCartCount(count) {
    cartCountEls.forEach(function (el) { el.textContent = '(' + count + ')'; });
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCartDrawer)
      .catch(function () {});
  }

  function renderCartDrawer(cart) {
    updateCartCount(cart.item_count);
    var body = document.querySelector('[data-cart-body]');
    var foot = document.querySelector('[data-cart-foot]');
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML = '<p class="empty">Your cart is empty.</p>';
    } else {
      body.innerHTML = cart.items.map(function (item) {
        return (
          '<div class="line-item">' +
            '<div class="li-img"><img src="' + item.image + '" alt="" style="width:100%;height:100%;object-fit:cover"></div>' +
            '<div style="flex:1">' +
              '<div class="li-name">' + item.product_title + '</div>' +
              '<div class="li-var">' + item.variant_title + '</div>' +
              '<div class="li-row">' +
                '<div class="li-qty" data-key="' + item.key + '" data-qty="' + item.quantity + '">' +
                  '<button type="button" class="qty-btn" data-qty-dir="-1" aria-label="Decrease quantity">&minus;</button>' +
                  '<span class="qty-val">' + item.quantity + '</span>' +
                  '<button type="button" class="qty-btn" data-qty-dir="1" aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<div class="li-price">' + formatMoney(item.final_line_price) + '</div>' +
              '</div>' +
              '<a data-remove-line="' + item.key + '" class="li-remove">Remove</a>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    }

    if (foot) {
      foot.querySelector('[data-cart-subtotal]').textContent = formatMoney(cart.total_price);
      /* The drawer's checkout is an <a>, not a <button> — setting .disabled
         on it is a no-op for anchors, so it stayed fully clickable (and
         navigated to a checkout with nothing in it) even on an empty cart.
         A real class + guarding the click is what actually stops it. */
      foot.querySelector('.checkout').classList.toggle('is-disabled', cart.items.length === 0);
    }
  }

  var drawerCheckout = document.querySelector('.drawer-foot .checkout');
  if (drawerCheckout) {
    drawerCheckout.addEventListener('click', function (e) {
      if (drawerCheckout.classList.contains('is-disabled')) {
        e.preventDefault();
        toast('Your cart is empty');
      }
    });
  }

  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN');
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-add-to-cart]');
    if (addBtn) {
      e.preventDefault();
      var variantId = addBtn.getAttribute('data-variant-id');
      if (!variantId) {
        toast('Please select a size');
        return;
      }
      addToCart(variantId, addBtn);
      return;
    }
    var buyBtn = e.target.closest('[data-buy-now]');
    if (buyBtn) {
      e.preventDefault();
      var buyVariantId = buyBtn.getAttribute('data-variant-id');
      if (!buyVariantId) {
        toast('Please select a size');
        return;
      }
      buyNow(buyVariantId, buyBtn);
      return;
    }
    var removeLink = e.target.closest('[data-remove-line]');
    if (removeLink) {
      e.preventDefault();
      changeLine(removeLink.getAttribute('data-remove-line'), 0);
      return;
    }
    var qtyBtn = e.target.closest('[data-qty-dir]');
    if (qtyBtn) {
      e.preventDefault();
      var qtyWrap = qtyBtn.closest('.li-qty');
      var key = qtyWrap.getAttribute('data-key');
      var current = parseInt(qtyWrap.getAttribute('data-qty'), 10) || 0;
      var dir = parseInt(qtyBtn.getAttribute('data-qty-dir'), 10);
      changeLine(key, Math.max(0, current + dir));
    }
  });

  function addToCart(variantId, triggerEl) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
        return r.json();
      })
      .then(function () {
        toast('Added to cart');
        openCart();
      })
      .catch(function (err) { toast(err.message || 'That size is out of stock'); });
  }

  /* Buy Now: adds the selected variant to the cart same as Add to Cart, then
     jumps straight to /checkout instead of opening the cart drawer — no
     Shopify dynamic checkout button involved. */
  function buyNow(variantId, triggerEl) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
        return r.json();
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) { toast(err.message || 'That size is out of stock'); });
  }

  function changeLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(renderCartDrawer)
      .catch(function () {});
  }

  /* ---------- PDP variant picker (e.g. the bundles' Pack of 6 / Pack of 2) ----------
     Swaps the id the add-to-cart button posts, plus the visible price and the
     stock note. Only present when the product has more than one variant. */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var btns = picker.querySelectorAll('[data-variant-option]');
    var addBtn = document.querySelector('.pdp-add[data-add-to-cart]');
    var buyBtn = document.querySelector('.pdp-buy-now[data-buy-now]');
    var priceEl = document.querySelector('[data-variant-price]');
    var note = document.querySelector('[data-stock-note]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (o) { o.classList.remove('active'); });
        btn.classList.add('active');
        var available = btn.getAttribute('data-variant-available') === 'true';
        var variantId = btn.getAttribute('data-variant-id');
        if (addBtn) {
          addBtn.setAttribute('data-variant-id', variantId);
          addBtn.disabled = !available;
          addBtn.textContent = available ? 'Add to cart' : 'Out of stock';
        }
        if (buyBtn) {
          buyBtn.setAttribute('data-variant-id', variantId);
          buyBtn.disabled = !available;
          buyBtn.textContent = available ? 'Buy it now' : 'Out of stock';
        }
        if (priceEl) priceEl.textContent = btn.getAttribute('data-price');
        if (note) note.hidden = available;
      });
    });
  });

  /* PDP zoom-on-hover removed by request — the .zoom-frame handler that tracked
     the cursor and scaled the image on hover is gone, along with its class in
     main-product.liquid and its CSS in theme.css. */

  /* ---------- PDP gallery: one-at-a-time scroll-snap slider on every screen
     size. Native touch swipe/trackpad scroll works for free via
     overflow-x:auto + scroll-snap-type in theme.css; this adds the
     keyboard-accessible equivalent (region is focusable via tabindex="0")
     plus the click-through prev/next buttons a desktop mouse needs since it
     has no swipe gesture. ---------- */
  document.querySelectorAll('[data-pdp-gallery]').forEach(function (gallery) {
    var items = gallery.querySelectorAll('[data-pdp-gallery-item]');
    gallery.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      if (!items.length) return;
      e.preventDefault();
      var dir = e.key === 'ArrowRight' ? 1 : -1;
      gallery.scrollBy({ left: dir * items[0].getBoundingClientRect().width, behavior: 'smooth' });
    });

    var media = gallery.parentElement;
    var prevBtn = media.querySelector('[data-pdp-gallery-prev]');
    var nextBtn = media.querySelector('[data-pdp-gallery-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () {
      gallery.scrollBy({ left: -items[0].getBoundingClientRect().width, behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      gallery.scrollBy({ left: items[0].getBoundingClientRect().width, behavior: 'smooth' });
    });

    /* Pagination dots. Tapping one scrolls the slider to that image; scrolling
       or swiping lights the matching dot. scrollLeft is set from offsetLeft
       rather than using scrollIntoView, which would also scroll the page
       vertically to bring the slider into view.

       The desktop thumbnail reel below the gallery is driven by the exact same
       index — one control group per selector, both kept in sync by setActive —
       so a click on either, or a swipe of the slider itself, always leaves the
       dot and the thumb agreeing on which image is showing. */
    if (!items.length) return;
    var groups = ['[data-pdp-dot]', '[data-pdp-thumb]'].map(function (sel) {
      return Array.prototype.slice.call(media.querySelectorAll(sel));
    }).filter(function (g) { return g.length; });
    if (!groups.length) return;

    groups.forEach(function (btns) {
      btns.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          gallery.scrollTo({ left: items[i].offsetLeft - items[0].offsetLeft, behavior: 'smooth' });
        });
      });
    });

    function setActive(index) {
      groups.forEach(function (btns) {
        btns.forEach(function (b, i) { b.classList.toggle('active', i === index); });
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          setActive(Array.prototype.indexOf.call(items, entry.target));
        });
      }, { root: gallery, threshold: 0.6 });
      items.forEach(function (item) { io.observe(item); });
    } else {
      /* Fallback for browsers without IntersectionObserver: derive the index
         from scroll position instead. */
      gallery.addEventListener('scroll', function () {
        var w = items[0].getBoundingClientRect().width || 1;
        setActive(Math.round(gallery.scrollLeft / w));
      }, { passive: true });
    }
  });

  /* ---------- PDP: give the gallery a fixed, product-independent height on
     desktop/web (see syncGalleryHeight) — originally this forced the gallery's
     bottom edge onto the trust-badges section's bottom edge, by measuring and
     setting a real pixel height directly — rather than relying on the CSS
     align-items:stretch + flex + grid-auto-rows:100% chain, which silently
     stops working the moment width and height are both set explicitly on
     the image (aspect-ratio has no effect once neither dimension is auto,
     per spec), so the result otherwise depends on every link in that chain
     resolving exactly right in every browser. This is the guaranteed-correct
     backstop: whatever the CSS produces, JS overrides it with the real
     measured distance. No-op below 981px, where the gallery isn't a sibling
     column of the info block at all. ---------- */
  (function () {
    var media = document.querySelector('.pdp-media');
    var gallery = media && media.querySelector('[data-pdp-gallery]');
    var trustBadges = document.querySelector('.trust-badges.pdp-trust');
    if (!media || !gallery || !trustBadges) return;

    function syncGalleryHeight() {
      if (window.innerWidth < 981) {
        media.style.height = '';
        gallery.style.height = '';
        return;
      }
      /* Fixed photo size for EVERY product (by request, 2026-10): 80% of the
         viewport height, capped at the column's 3:4 height. It used to follow
         the info column's height (gallery bottom = trust badges bottom), so a
         product with a longer description got a visibly bigger photo — Gul
         products came out larger than Held Close ones. */
      var thumbs = media.querySelector('[data-pdp-thumbs]');
      var thumbsHeight = thumbs ? thumbs.getBoundingClientRect().height : 0;
      var width = media.getBoundingClientRect().width;
      var galleryHeight = Math.round(Math.min(window.innerHeight * 0.8, width * 4 / 3));
      if (galleryHeight < 200) return; // sanity floor — something's still settling
      media.style.height = (galleryHeight + thumbsHeight) + 'px';
      gallery.style.height = galleryHeight + 'px';
    }

    window.addEventListener('load', syncGalleryHeight);
    window.addEventListener('resize', syncGalleryHeight);
    // Fonts/description reflow can shift the info column's height slightly
    // after the initial paint — a couple of delayed re-checks catch that
    // without needing a full ResizeObserver wired up for a one-time layout.
    setTimeout(syncGalleryHeight, 300);
    setTimeout(syncGalleryHeight, 1200);
  })();

  /* ---------- PDP lightbox: click any gallery image to open it full-screen,
     with prev/next arrows and a thumbnail reel strip along the bottom.
     One lightbox per page (there's only one product's gallery on a PDP), so
     this just grabs the single instance rather than looping over a list. ---------- */
  (function () {
    var lightbox = document.querySelector('[data-pdp-lightbox]');
    if (!lightbox) return;
    var stage = lightbox.querySelector('[data-pdp-lightbox-stage]');
    var slides = lightbox.querySelectorAll('[data-pdp-lightbox-slide]');
    var thumbs = lightbox.querySelectorAll('[data-pdp-lightbox-thumb]');
    var prevBtn = lightbox.querySelector('[data-pdp-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-pdp-lightbox-next]');
    var closeBtn = lightbox.querySelector('[data-pdp-lightbox-close]');
    if (!slides.length) return;

    function setActiveThumb(index) {
      thumbs.forEach(function (t, i) { t.classList.toggle('active', i === index); });
    }

    function goTo(index, smooth) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      stage.scrollTo({ left: slides[index].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      setActiveThumb(index);
    }

    function currentIndex() {
      var w = slides[0].getBoundingClientRect().width || 1;
      return Math.round(stage.scrollLeft / w);
    }

    function open(index) {
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      goTo(index, false);
    }

    function close() {
      lightbox.hidden = true;
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-pdp-lightbox-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        if (e.target.closest('video')) return; // let video controls work normally
        open(parseInt(trigger.getAttribute('data-index'), 10) || 0);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex() - 1, true); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex() + 1, true); });
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i, true); });
    });

    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') goTo(currentIndex() + 1, true);
      else if (e.key === 'ArrowLeft') goTo(currentIndex() - 1, true);
    });

    var resizeTimer;
    stage.addEventListener('scroll', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { setActiveThumb(currentIndex()); }, 80);
    }, { passive: true });
  })();

  /* ---------- Pincode lookup (India Post API), optional enhancement on the cart/address step ---------- */
  var pincodeInput = document.querySelector('[data-pincode-input]');
  if (pincodeInput) {
    var pincodeStatus = document.querySelector('[data-pincode-status]');
    pincodeInput.addEventListener('input', function () {
      var digits = pincodeInput.value.replace(/\D/g, '').slice(0, 6);
      pincodeInput.value = digits;
      if (digits.length !== 6) {
        if (pincodeStatus) pincodeStatus.textContent = '';
        return;
      }
      if (pincodeStatus) pincodeStatus.textContent = 'Checking…';
      fetch('https://api.postalpincode.in/pincode/' + digits)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var result = Array.isArray(data) ? data[0] : null;
          if (!pincodeStatus) return;
          if (result && result.Status === 'Success' && result.PostOffice && result.PostOffice.length) {
            var po = result.PostOffice[0];
            pincodeStatus.textContent = 'Delivers to ' + po.District + ', ' + po.State;
            pincodeStatus.style.color = 'var(--clay)';
          } else {
            pincodeStatus.textContent = 'That pincode could not be found';
            pincodeStatus.style.color = 'var(--bad)';
          }
        })
        .catch(function () {
          if (pincodeStatus) pincodeStatus.textContent = '';
        });
    });
  }

  /* ---------- Our World page: collage placeholder + staggered moments slideshow ---------- */
  var collage = document.querySelector('[data-collage]');
  if (collage) {
    var collageSlides = collage.querySelectorAll('.slide');
    var collageIndex = 0;
    setInterval(function () {
      collageSlides[collageIndex].classList.remove('active');
      collageIndex = (collageIndex + 1) % collageSlides.length;
      collageSlides[collageIndex].classList.add('active');
    }, 2600);
  }

  function cycleColumn(col, selector) {
    var imgs = col.querySelectorAll(selector || '.moments-photo');
    var index = 0;
    return function () {
      imgs[index].classList.remove('active');
      index = (index + 1) % imgs.length;
      imgs[index].classList.add('active');
    };
  }

  /* Single alternating sequence, not two independent loops: left changes at
     1.5s/6.5s/11.5s..., right changes at 4s/9s/14s... — i.e. one column
     advances every 2.5s, alternating which column it is, so the overall
     photo order reads 1-2-3-4-5-6 left-right-left-right-left-right with an
     image change every 2.5s (first one at 1.5s). Desktop only. */
  var momentsLeft = document.querySelector('[data-moments-col="left"]');
  var momentsRight = document.querySelector('[data-moments-col="right"]');
  if (momentsLeft && momentsRight && window.innerWidth > 720) {
    var advanceLeft = cycleColumn(momentsLeft);
    setTimeout(function () {
      advanceLeft();
      setInterval(advanceLeft, 5000);
    }, 1500);
    var advanceRight = cycleColumn(momentsRight);
    setTimeout(function () {
      advanceRight();
      setInterval(advanceRight, 5000);
    }, 4000);
  }

  /* ---------- Mobile single-column moments slider (1→2→3→4→5→6) ---------- */
  var momentsMobile = document.querySelector('[data-moments-mobile]');
  if (momentsMobile && window.innerWidth <= 720) {
    var advanceMobileMoments = cycleColumn(momentsMobile.querySelector('.img'));
    setTimeout(function () {
      advanceMobileMoments();
      setInterval(advanceMobileMoments, 3000);
    }, 1500);
  }

  /* ---------- Mobile single-column gifting slider (1→2), same pattern ---------- */
  var giftingMobile = document.querySelector('[data-gifting-mobile]');
  if (giftingMobile && window.innerWidth <= 720) {
    setInterval(cycleColumn(giftingMobile.querySelector('.img')), 3000);
  }

  /* ---------- Footer scattered dots ----------
     Measures the footer's real rendered size (percentages alone get this
     wrong once the footer goes very tall on mobile, where everything
     stacks into one column). The card takes up nearly the whole footer
     (margins are only ~32-48px), so a single grid over the full footer
     rect almost always lands its jittered cells inside the card and
     leaves the thin open margin empty by chance. Instead this scatters
     two regions on purpose: a grid over the card's own footprint (visible
     through its translucency) AND a separate strip of dots tiled along
     each of the four margin bands outside the card — so the open area
     reliably gets its own dots instead of just whatever leaks over. */
  /* Seeded PRNG (mulberry32), reset to the same fixed seed on every call —
     so the "random" scatter comes out byte-for-byte identical on every page
     load/refresh/navigation instead of reshuffling each time, while still
     looking organic rather than a hand-placed grid. */
  function makeSeededRandom(seed) {
    return function () {
      seed |= 0; seed = (seed + 0x6D2B79F5) | 0;
      var t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  var FOOT_DOT_ANIMS = ['foot-float-a', 'foot-float-b', 'foot-float-c', 'foot-float-d'];

  function placeFooterDots() {
    var footer = document.querySelector('footer');
    var layer = footer && footer.querySelector('.foot-dots');
    var card = footer && footer.querySelector('.foot-card');
    if (!footer || !layer) return;
    layer.innerHTML = '';

    var fRect = footer.getBoundingClientRect();
    var fW = fRect.width, fH = fRect.height;
    if (!fW || !fH) return;

    var isMobile = window.innerWidth <= 720;
    var cellSize = isMobile ? 150 : 230; // bigger gap, both under the card and in the outer margins
    var size = isMobile ? 19 : 24; // 20% smaller on mobile
    var rand = makeSeededRandom(20260630); // fixed seed -> same layout every time
    var dotIndex = 0;

    function addDot(x, y) {
      var dot = document.createElement('div');
      dot.className = 'foot-dot';
      dot.style.left = x + 'px';
      dot.style.top = y + 'px';
      dot.style.width = size + 'px';
      dot.style.height = size + 'px';
      dot.style.setProperty('--dot-anim', FOOT_DOT_ANIMS[dotIndex % FOOT_DOT_ANIMS.length]);
      dot.style.setProperty('--dot-dur', (1.4 + rand() * 1.2).toFixed(2) + 's');
      dot.style.setProperty('--dot-delay', (rand() * 3).toFixed(2) + 's');
      dotIndex++;
      layer.appendChild(dot);
    }

    function scatterGrid(x0, y0, w, h) {
      if (w <= 0 || h <= 0) return;
      var cols = Math.max(1, Math.round(w / cellSize));
      var rows = Math.max(1, Math.round(h / cellSize));
      var cellW = w / cols, cellH = h / rows;
      var jitter = 0.32; // fraction of cell size a dot may drift from its cell center
      for (var i = 0; i < rows; i++) {
        for (var j = 0; j < cols; j++) {
          var cx = x0 + cellW * (j + 0.5) + (rand() * 2 - 1) * jitter * cellW;
          var cy = y0 + cellH * (i + 0.5) + (rand() * 2 - 1) * jitter * cellH;
          addDot(cx, cy);
        }
      }
    }

    // Places an exact, fixed number of dots inside one rect — each one at
    // the best of a few random candidates, "best" meaning farthest from
    // every point already placed (corners and earlier rects included). That
    // farthest-point rule is what fills empty-looking patches and stops two
    // dots from ever landing close enough to read as aligned, but the COUNT
    // per rect is fixed ahead of time rather than chosen by weighted random
    // picks — random picks across only ~11 dots were a small enough sample
    // that left/right ended up lopsided purely by chance with this seed.
    function scatterRectFarthest(rect, count, placed, tries) {
      if (rect.w <= 0 || rect.h <= 0) return;
      for (var n = 0; n < count; n++) {
        var best = null, bestDist = -1;
        for (var t = 0; t < tries; t++) {
          var cand = { x: rect.x + rand() * rect.w, y: rect.y + rand() * rect.h };
          if (placed.length === 0) { best = cand; break; }
          var minDist = Infinity;
          for (var p = 0; p < placed.length; p++) {
            var dx = cand.x - placed[p].x, dy = cand.y - placed[p].y;
            var d = dx * dx + dy * dy;
            if (d < minDist) minDist = d;
          }
          if (minDist > bestDist) { bestDist = minDist; best = cand; }
        }
        placed.push(best);
        addDot(best.x, best.y);
      }
    }

    if (card) {
      var cRect = card.getBoundingClientRect();
      var cardLeft = cRect.left - fRect.left;
      var cardTop = cRect.top - fRect.top;
      var cardW = cRect.width, cardH = cRect.height;
      var cardRight = cardLeft + cardW, cardBottom = cardTop + cardH;

      scatterGrid(cardLeft, cardTop, cardW, cardH); // under the translucent card

      var bandTop = Math.max(0, cardTop), bandBottom = Math.max(0, fH - cardBottom);
      var bandLeft = Math.max(0, cardLeft), bandRight = Math.max(0, fW - cardRight);

      // One dot pinned inside a small zone at each literal corner first —
      // guarantees all four corners read as covered, not left to chance.
      var marginPoints = [];
      var cz = function (mw, mh) { return { w: Math.max(8, Math.min(mw, 40)), h: Math.max(8, Math.min(mh, 40)) }; };
      var tl = cz(bandLeft, bandTop), tr = cz(bandRight, bandTop);
      var bl = cz(bandLeft, bandBottom), br = cz(bandRight, bandBottom);
      [
        { x: 0, y: 0, w: tl.w, h: tl.h },
        { x: fW - tr.w, y: 0, w: tr.w, h: tr.h },
        { x: 0, y: fH - bl.h, w: bl.w, h: bl.h },
        { x: fW - br.w, y: fH - br.h, w: br.w, h: br.h }
      ].forEach(function (zone) {
        var p = { x: zone.x + rand() * zone.w, y: zone.y + rand() * zone.h };
        marginPoints.push(p);
        addDot(p.x, p.y);
      });

      // Remaining margin dots (15 total minus the 4 corners already placed)
      // split across the four sides in proportion to each side's own length
      // — a fixed, deterministic share per side, so left/right/top/bottom
      // always come out balanced instead of however the random picks landed.
      var remaining = Math.max(0, 15 - 4);
      var sideLengths = [fW, fW, bandLeft > 0 ? fH : 0, bandRight > 0 ? fH : 0];
      var totalSideLength = sideLengths[0] + sideLengths[1] + sideLengths[2] + sideLengths[3];
      var sideCounts = sideLengths.map(function (len) {
        return totalSideLength > 0 ? Math.round((len / totalSideLength) * remaining) : 0;
      });
      var sideDrift = remaining - (sideCounts[0] + sideCounts[1] + sideCounts[2] + sideCounts[3]);
      sideCounts[0] += sideDrift; // fold any rounding leftover into the top side

      var marginRects = [
        { x: 0, y: 0, w: fW, h: bandTop },
        { x: 0, y: Math.min(fH, cardBottom), w: fW, h: bandBottom },
        { x: 0, y: 0, w: bandLeft, h: fH },
        { x: Math.min(fW, cardRight), y: 0, w: bandRight, h: fH }
      ];
      marginRects.forEach(function (rect, i) {
        scatterRectFarthest(rect, sideCounts[i], marginPoints, 8);
      });
    } else {
      scatterGrid(0, 0, fW, fH);
    }
  }
  if (document.querySelector('footer .foot-dots')) {
    window.addEventListener('load', placeFooterDots);
    // Custom @font-face fonts can still be swapping in after 'load' fires,
    // which reflows the footer's text (accordion lists, address, etc.) and
    // changes its height — re-measuring here catches that so the dots stay
    // aligned with the footer's actual final size instead of a pre-font-swap
    // measurement.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(placeFooterDots).catch(function () {});
    }
    var dotResizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(dotResizeTimer);
      dotResizeTimer = setTimeout(placeFooterDots, 200);
    });
  }
})();
